import React from 'react';
const ContactUs = () => {
  
  return (
    <div>
      <h2>Contact Prime Apps LLC</h2>

      {(
        <div style={{ marginTop: '1rem' }}>
          <h4>Company Contact Info</h4>
          <p><strong>Email:</strong> hr@primeappsllc.net</p>
          <p><strong>Phone:</strong> coming soon ...</p>
          <p><strong>Website:</strong> https://primeappsllc.net</p>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
